import httpClient from '../httpClient';

export async function getAct(id: string) {
  try {
    const response = await httpClient.get(`/api/act/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Produto DAF: ' + error);
  }
}

export async function getAllActs() {
  try {
    const response = await httpClient.get(`/api/act`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Notas de Versão: ' + error);
  }
}

export async function getActsByUsuario() {
  try {
    const response = await httpClient.get(`/api/act/acts-por-usuario`);

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter ACTs do usuário: ' + error);
  }
}
